import { LeftCircleOutlined } from '@ant-design/icons';
import './App.css';
import {
    Badge,
    Button,
    Flex,
    Space,
    Timeline,
    TimelineItemProps,
} from 'antd';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { JSX } from 'react/jsx-runtime';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Update = () => {
    const n = useNavigate();
    const data = [
        {
            wiki: <Space direction='vertical' style={{width: '100%'}}>
                <Text>1. 添加了棉花糖批量删除的功能</Text>
                <Text>2. 添加了棉花糖右键删除的功能</Text>
                <Text>3. 修复了棉花糖列表无法回到之前阅读位置的bug</Text>
                <Text>4. 添加了棉花糖上次阅读位置的标签<Badge color='purple' count='上次阅读到这篇喔'/></Text>
                <Text>5. 修改了首页主题</Text>
                <Text>6. rua了一下可爱的狐狐</Text>
            </Space>,
            date: '2025-12-15',
        },
        {
            wiki: <Space direction='vertical' style={{width: '100%'}}>
                <Text>1. 添加了可爱的鼠标指针</Text>
                <Text>2. 添加了深色模式</Text>
                <Text>3. 添加了页面切换过场动画</Text>
                <Text>4. 音声页面大变样</Text>
                <Text>5. 修复了登录后又跳回去的问题</Text>
                <Text>6. rua了一下可爱的狐狐</Text>
            </Space>,
            date: '2025-12-12',
        }
    ]
    let items: TimelineItemProps[] | { children: JSX.Element }[] | undefined =
        [];
    data.forEach(
        (element: {
            wiki: any;
            date: string | number | Date | dayjs.Dayjs | null | undefined;
        }) => {
            const date = dayjs(element.date).format('YYYY-MM-DD');
            items?.push({
                children: (
                    <>
                        <Title level={4} style={{ margin: '0' }}>
                            {date}
                        </Title>
                        {element.wiki}
                    </>
                ),
            });
        }
    );
    // 渲染数据
    return (
        <>
            <Flex align="center" gap={10}>
        <Button
          type="primary"
          shape="circle"
          icon={<LeftCircleOutlined />}
          onClick={() => n("/dashboard")}
        />
        <Title level={3} style={{ margin: "15px 0" }}>
          更新日志
        </Title>
        <Badge color='#66CCFF' count='喵' />
      </Flex>
            <br />
            <Timeline items={items} />
        </>
    );
};

export default Update;
